import { ROUTE_PATHS } from '@/shared/constants/routes';
import { useNavigate } from '@tanstack/react-router';
import React from 'react';

/** 404 화면 — 디자인 시스템 미정, 기본 Tailwind 스타일 */
export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <p className="text-6xl font-bold">404</p>
        <h2 className="text-xl font-semibold">페이지를 찾을 수 없습니다</h2>
        <p className="max-w-md text-gray-500">
          요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다. URL을 다시
          확인해주세요.
        </p>
        <div className="flex gap-2">
          <button
            type="button"
            className="rounded-md bg-gray-900 px-4 py-2 text-sm text-white"
            onClick={() => navigate({ to: ROUTE_PATHS.USERS })}
          >
            홈으로 이동
          </button>
          <button
            type="button"
            className="rounded-md border border-gray-300 px-4 py-2 text-sm"
            onClick={() => navigate({ to: '..' })}
          >
            이전 페이지
          </button>
        </div>
      </div>
    </div>
  );
};
